export default {
  index: [
    {
      path: '/zkpromoterladder',
      component: resolve => require(['./zkpromoterladderrewardIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/zkpromoter_ladder_reward/_router.js